import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './saveLoadPlanningSearch.actions.js';
import getters from './saveLoadPlanningSearch.getters.js';
import mutations from './saveLoadPlanningSearch.mutations.js';
import state from './saveLoadPlanningSearch.state.js';

BaseStore.registerModule('saveLoadPlanningSearch', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('saveLoadPlanningSearch');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
